//Index of Reducers

import { combineReducers } from "redux";
import adminNest from "./AdminNestReducer";
import adminMap from "./AdminMapReducer";
import login from "./LoginReducer";

export default combineReducers({
  adminNest,
  adminMap,
  login,
});
